import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Folder Alert"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-folder-alert',
    templateUrl: './icon-folder-alert.component.html',
    styleUrls: ['./icon-folder-alert.component.scss'],
    standalone: false
})
export class IconFolderAlertComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
